import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import moment from "moment";

import { publicImageUrl } from "../../../Config/publicImageUrl";
import { useStyles } from "./UserProfile.css";

class StudentDetails extends Component {
  render() {
    const { classes, userDetails } = this.props;
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <Paper className={classes.paper}>
            {userDetails.image ? (
              <img
                src={`${publicImageUrl}/${userDetails.image}`}
                alt={userDetails.firstName}
                style={{ width: 100, height: 100 }}
              />
            ) : (
              <Skeleton variant="circle" style={{ width: 100, height: 100 }} />
            )}
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Admission ID:</b>
              <div>{userDetails.admissionId}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Current Session:</b>
              <div>{userDetails.currentSession}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Full Name:</b>
              <div>
                {userDetails.firstName} {userDetails.middleName}
                {userDetails.lastName}
              </div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Gender:</b>
              <div>{userDetails.gender}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Class:</b>
              <div>{userDetails.studentClass}</div>
            </ListItem>
            {userDetails.faculty && (
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Faculty:</b>
                <div>{userDetails.faculty}</div>
              </ListItem>
            )}
            {userDetails.faculty && (
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Group:</b>
                <div>{userDetails.group}</div>
              </ListItem>
            )}
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Section:</b>
              <div>{userDetails.section}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Roll:</b>
              <div>{userDetails.roll}</div>
            </ListItem>

            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Admission Date:</b>
              <div>{moment(userDetails.admissionDate).format("LL")}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Scholarship Type:</b>
              <div>{userDetails.scholarshipType}</div>
            </ListItem>
          </Paper>
        </Grid>

        <Grid item container xs={12} sm={12} md={8} lg={8} xl={8}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.gridMobile}
          >
            <Paper className={classes.paper}>
              <div>General</div>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Date of Birth(AD):</b>
                <div>{moment(userDetails.dob_in_AD).format("LL")}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Date of Birth(BS):</b>
                <div>{userDetails.dob_in_BS}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Email :</b>
                <div>{userDetails.email ? userDetails.email : "N/A"}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mobile Number:</b>
                <div>{userDetails.phoneNo ? userDetails.phoneNo : "N/A"}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Blood Group:</b>
                <div>{userDetails.bloodGroup}</div>
              </ListItem>
            </Paper>
          </Grid>
          {userDetails.address && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Address</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>VDC:</b>
                  <div>{userDetails.address.vdc}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>City:</b>
                  <div>{userDetails.address.city}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>District:</b>
                  <div>{userDetails.address.district}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Province:</b>
                  <div>{userDetails.address.province}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Country:</b>
                  <div>{userDetails.address.country}</div>
                </ListItem>
              </Paper>
            </Grid>
          )}

          {userDetails.father && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              xl={6}
              lg={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Father</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Name:</b>
                  <div>{userDetails.father.name}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Phone Number:</b>
                  <div>{userDetails.father.phoneNo}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Email:</b>
                  <div>
                    {userDetails.father.email
                      ? userDetails.father.email
                      : "N/A"}
                  </div>
                </ListItem>
              </Paper>
            </Grid>
          )}

          {userDetails.mother && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              xl={6}
              lg={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Mother</div>
                <div style={{ display: "flex" }}>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Name:</b>
                    <div>{userDetails.mother.name}</div>
                  </ListItem>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Phone Number:</b>
                    <div>{userDetails.mother.phoneNo}</div>
                  </ListItem>
                  <ListItem divider>
                    <b style={{ flexGrow: 1 }}>Email:</b>
                    <div>
                      {userDetails.mother.email
                        ? userDetails.mother.email
                        : "N/A"}
                    </div>
                  </ListItem>
                </div>
              </Paper>
            </Grid>
          )}

          {userDetails.guardian && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              xl={6}
              lg={6}
              className={classes.gridMobile}
            >
              <Paper>
                <div>Guardian</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Name:</b>
                  <div>{userDetails.guardian.name}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Phone Number:</b>
                  <div>{userDetails.guardian.phoneNo}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Email:</b>
                  <div>
                    {userDetails.guardian.email
                      ? userDetails.guardian.email
                      : "N/A"}
                  </div>
                </ListItem>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(StudentDetails);
